import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

const clampText = (text = "", max = 120) => {
    const t = String(text).replace(/\s+/g, " ").trim();
    if (!t) return "";
    if (t.length <= max) return t;
    const cut = t.slice(0, max);
    const lastSpace = cut.lastIndexOf(" ");
    return `${cut.slice(0, Math.max(0, lastSpace)).trim()}...`;
};

function LatestArticles() {
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchLatestArticles = async () => {
            try {
                const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001/api/';
                const response = await fetch(`${apiUrl}articles/latest`);
                const data = await response.json();

                if (data.success) {
                    setArticles(data.articles);
                }
            } catch (error) {
                console.error('Error fetching latest articles:', error);
                toast.error('Failed to load articles');
            } finally {
                setLoading(false);
            }
        };

        fetchLatestArticles();
    }, []);

    if (loading) {
        return <div className="text-sm text-gray-600">Loading articles...</div>;
    }

    if (!articles.length) {
        return <div className="text-sm text-gray-600">No articles yet</div>;
    }

    return (
        <div className="space-y-0 rounded overflow-hidden">
            {articles.map((article, index) => (
                <Link
                    key={article.id}
                    to={article.href}
                    className={`block p-3 hover:opacity-80 transition-opacity ${index % 2 === 0 ? 'bg-white' : 'bg-gray-100'}`}
                >
                    <h3 className="text-sm font-bold text-gray-900 mb-1">
                        {article.title}
                    </h3>
                    <p className="text-xs text-gray-600 line-clamp-2">
                        {clampText(article.body, 120)}
                    </p>
                </Link>
            ))}
        </div>
    );
}

export default LatestArticles;